package dev.kuml.portal.web.api

/**
 * Builds the `GET /api/users/{id}/avatar` URL (R-16) -- deliberately DOM-free so it stays
 * unit-testable without a browser/jsdom.
 */
public object AvatarUrl {
    /**
     * @param cacheBuster typically the target user's `avatarUpdatedAt` (see
     *   `dev.kuml.portal.web.api.UserResponse.avatarUpdatedAt`) -- without it, a re-uploaded
     *   avatar would keep showing the previously cached image for up to 60s (the server's
     *   `Cache-Control: max-age=60`, see `dev.kuml.portal.server.account.AvatarRoutes`). `null`
     *   omits the query parameter entirely (e.g. a collaboration-presence avatar, which is always
     *   rendered fresh per WebSocket frame and never needs busting).
     */
    public fun forUser(
        userId: String,
        cacheBuster: String?,
    ): String {
        val base = "/api/users/${encodeUriComponent(userId)}/avatar"
        return if (cacheBuster == null) base else "$base?v=${encodeUriComponent(cacheBuster)}"
    }

    /** Thin wrapper around the global JS `encodeURIComponent` -- no Kotlin/JS stdlib binding
     * exists for it, so it is called via `js(...)` the same way the rest of this codebase reaches
     * for browser globals with no typed Kotlin binding. */
    private fun encodeUriComponent(value: String): String = js("encodeURIComponent(value)") as String
}
